import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api";
import { EnumSearchQueryParams } from "../search.types";

export const mapLeverageProductsIndicationFromQuery = (urlParams: URLSearchParams): EnumLeverageProductsIndication => {
    if (urlParams.get(EnumSearchQueryParams.WikifoliosWithLeverageProducts) === "true") {
        return EnumLeverageProductsIndication.WikifoliosWithLeverageProducts;
    }

    if (urlParams.get(EnumSearchQueryParams.WikifoliosWithoutLeverageProducts) === "true") {
        return EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts;
    }

    return EnumLeverageProductsIndication.AllWikifolios;
};

export const mapLeverageProductsIndicationToQuery = (leverageProductsIndication: EnumLeverageProductsIndication) => {
    if (leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithLeverageProducts) {
        return `${EnumSearchQueryParams.WikifoliosWithLeverageProducts}=true`;
    }

    if (leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts) {
        return `${EnumSearchQueryParams.WikifoliosWithoutLeverageProducts}=true`;
    }

    return "";
};
